import { EnvelopeIcon, EnvelopeOpenIcon } from '@heroicons/react/24/outline'
import { useRecoilState } from 'recoil'
import { ContentView } from '../../../api/client'
import { userState } from '../../../store/DomainStore'
import BaseActionButton from './BaseActionButton'

type Props = {
    content: ContentView
    onMarkAsReadClick: (content: ContentView) => void
    onMarkAsUnreadClick: (content: ContentView) => void
    loading: boolean
}

export default function ReadStatusButton(props: Props) {
    const { content, onMarkAsReadClick, onMarkAsUnreadClick, loading } = props
    const [user] = useRecoilState(userState)

    const readByMe = !!content.readReceipts.find((receipt) => receipt.userId === user.id)

    return (
        <div className="relative">
            {readByMe && (
                <BaseActionButton
                    tooltip={`Mark as unread.`}
                    loading={loading}
                    colour="blue"
                    actionAlreadyApplied={!readByMe}
                    icon={<EnvelopeOpenIcon />}
                    onActionClick={async () => {
                        onMarkAsUnreadClick(content)
                    }}
                    isActionQueued={false}
                />
            )}
            {!readByMe && (
                <BaseActionButton
                    tooltip={`Mark as read.`}
                    loading={loading}
                    colour="blue"
                    actionAlreadyApplied={!readByMe}
                    icon={<EnvelopeIcon />}
                    onActionClick={async () => {
                        onMarkAsReadClick(content)
                    }}
                    isActionQueued={false}
                />
            )}
        </div>
    )
}
